"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datePickerTheme = void 0;
exports.getDisabledBumperStyles = getDisabledBumperStyles;
exports.getTypeRampPropsDay = getTypeRampPropsDay;
exports.getTypeRampPropsDayOfWeek = getTypeRampPropsDayOfWeek;
exports.getTypeRampPropsMonthYear = getTypeRampPropsMonthYear;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _colors = require("../../../../constants/colors");
var _layers = require("../../../../constants/layers");
var _spacing = require("../../../../constants/spacing");
const {
  neutral,
  neutralLight10,
  neutralLight20,
  neutralLight40,
  neutralDark20,
  neutralDark30,
  neutralDark40,
  buttonDefault,
  focusLight10,
  visBlueLight30
} = _designTokens.lodestarColors;
const {
  blue25,
  blue50,
  blue75,
  neutral60,
  neutral75,
  neutral400,
  neutral800,
  blue500,
  blue600
} = _designTokens.ursaColors;
const datePickerTheme = (0, _sdsThemeInternal.themed)({
  backgroundColor: (0, _designTokensReact.color)("color--background--surfaces--work", neutralLight40),
  boxShadow: {
    "lodestar-light": _layers.shadows.context(),
    "ursa-light": (0, _designTokensReact.color)("elevation--shadow-2")
  },
  borderRadius: {
    "lodestar-light": `${_spacing.sizes.xxSmall}px`,
    "ursa-light": _designTokens.space.space20
  },
  color: (0, _designTokensReact.color)("color--text--neutral--default", neutralDark40),
  dayContainerMarginTop: {
    "lodestar-light": "18px",
    "ursa-light": _designTokens.space.space30
  },
  footer: {
    marginTop: {
      "lodestar-light": _designTokens.space.space60,
      "ursa-light": _designTokens.space.space30
    },
    buttonAppearance: {
      apply: {
        "lodestar-light": "primary",
        "ursa-light": "secondary-filled"
      },
      standard: {
        "lodestar-light": "secondary",
        "ursa-light": "secondary-filled"
      }
    }
  },
  dateRangePickerInputTextSeparatorColor: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--strong", neutralDark30),
    "ursa-light": (0, _designTokensReact.color)("color--text--neutral--default", neutral800)
  },
  dayBackgroundColorActive: {
    "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default", neutralLight10),
    "ursa-light": (0, _designTokensReact.color)("color--background--neutral--default", neutral75)
  },
  dayBackgroundColorFocused: {
    "lodestar-light": buttonDefault,
    //no token exists
    "ursa-light": "transparent"
  },
  dayBackgroundColorFocusedSelecting: {
    "lodestar-light": buttonDefault,
    //no token exists
    "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest", blue50)
  },
  dayBackgroundColorHover: {
    "lodestar-light": buttonDefault,
    //no token exists
    "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weak", neutral60)
  },
  dayBackgroundColorSelected: {
    "lodestar-light": focusLight10,
    //no token exists
    "ursa-light": (0, _designTokensReact.color)("color--background--primary--strong", blue500)
  },
  dayBackgroundColorToday: {
    "lodestar-light": "transparent",
    "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest", blue25)
  },
  dayBackgroundColorTodayActive: {
    "lodestar-light": buttonDefault,
    //no token exists
    "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest", blue50)
  },
  dayBackgroundColorTodayHover: {
    "lodestar-light": buttonDefault,
    //no token exists
    "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest", blue50)
  },
  dayBorderColorToday: {
    "lodestar-light": (0, _colors.toRgba)("#000000", 0.4),
    //no token exists
    "ursa-light": "transparent"
  },
  dayBorderRadius: {
    "lodestar-light": "2px",
    "ursa-light": _designTokens.border.radius20
  },
  dayColor: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--default", neutralDark30),
    "ursa-light": (0, _designTokensReact.color)("color--text--neutral--strong", neutral800)
  },
  dayColorDisabled: {
    "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--strong", neutral),
    "ursa-light": (0, _designTokensReact.color)("color--text--neutral--weaker", "#71768A") //no ursa fallback exists
  },

  dayColorSelected: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--default", neutralDark30),
    "ursa-light": (0, _designTokensReact.color)("color--text--primary--weakest", blue25)
  },
  dayColorToday: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--default", neutralDark30),
    "ursa-light": (0, _designTokensReact.color)("color--text--primary--default", blue600)
  },
  dayFocusRingGap: {
    "lodestar-light": 2,
    "ursa-light": 0
  },
  dayFontWeightSelected: {
    "lodestar-light": 600,
    "ursa-light": _designTokens.typography.fontWeight.bold
  },
  dayFontWeightToday: {
    "lodestar-light": 600,
    "ursa-light": _designTokens.typography.fontWeight.bold
  },
  dayLabelColor: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--weak", neutralDark20),
    "ursa-light": (0, _designTokensReact.color)("color--text--neutral--weaker", neutral400)
  },
  dayLabelFontSize: {
    "lodestar-light": "14px",
    "ursa-light": _designTokens.typography.fontSize.size20
  },
  dayMargin: {
    "lodestar-light": "0",
    "ursa-light": `0 ${_designTokens.space.space20}`
  },
  dayRowGap: {
    "lodestar-light": "0",
    "ursa-light": _designTokens.space.space10
  },
  dayTransitionDuration: {
    "ursa-light": "75ms",
    "lodestar-light": "0s"
  },
  padding: {
    "lodestar-light": `${_spacing.sizes.large}px 28px`,
    "ursa-light": _designTokens.space.space40
  },
  topButtonType: {
    "lodestar-light": "borderless",
    "ursa-light": "secondary-empty"
  },
  dayWidth: {
    "lodestar-light": "40px",
    "ursa-light": _designTokens.space.space60
  },
  dayInnerPadding: {
    "lodestar-light": "0",
    "ursa-light": "2px"
  },
  dateRangeLimitBorderFlatteningType: {
    "lodestar-light": "button",
    "ursa-light": "background"
  },
  dateRangePickerInRangeBackgroundColor: {
    inProgress: {
      "lodestar-light": buttonDefault,
      //no token exists
      "ursa-light": (0, _designTokensReact.color)("color--background--primary--weaker", blue75)
    },
    selected: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--primary--weakest", visBlueLight30),
      "ursa-light": (0, _designTokensReact.color)("color--background--primary--weakest", blue50)
    }
  },
  menuOffset: {
    "lodestar-light": 1,
    "ursa-light": 2
  },
  yearSelector: {
    backgroundColor: {
      hover: {
        "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--weak", neutralLight20),
        "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker", neutral60)
      },
      expanded: {
        "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default", neutralLight10),
        "ursa-light": (0, _designTokensReact.color)("color--background--neutral--default", neutral75)
      }
    },
    minheight: {
      "lodestar-light": "32px",
      "ursa-light": "none"
    },
    iconHeight: {
      "lodestar-light": "24px",
      "ursa-light": "none"
    }
  }
});
exports.datePickerTheme = datePickerTheme;
function getTypeRampPropsMonthYear(themeMode) {
  if (themeMode.includes("ursa")) {
    return {
      system: "ursa",
      variant: "Inter--16px--700w"
    };
  }
  return {
    system: "lodestar",
    variant: "headlineSmall"
  };
}
function getTypeRampPropsDayOfWeek(themeMode) {
  if (themeMode.includes("ursa")) {
    return {
      system: "ursa",
      variant: "Inter--12px--500w"
    };
  }
  return {
    system: "lodestar",
    variant: "headerSmall"
  };
}
function getTypeRampPropsDay(themeMode) {
  if (themeMode.includes("ursa")) {
    return {
      system: "ursa",
      variant: "Inter--14px--400w"
    };
  }
  return {
    system: "lodestar",
    variant: "headerLarge"
  };
}

// implements faux-rounded corners for days adjacent to invalid days, for ursa theme
function getDisabledBumperStyles(_ref) {
  let {
    themeMode
  } = _ref;
  if (themeMode !== "ursa-light") return "";
  return `
        &:before,
        &:after {
            content: "";
            width: 10px;
            background-color: ${datePickerTheme.backgroundColor(themeMode)};
            height: 32px;
            position: absolute;
            top: -2px;
            mask-repeat: no-repeat;
            mask-size: contain;
            z-index: 1;
            pointer-events: none;
        }
        &:before {
            left: -14px;
            mask-image: url("data:image/svg+xml;base64,PHN2ZwogICB3aWR0aD0iMTAiCiAgIGhlaWdodD0iMzIiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGgKICAgICBkPSJNIDAsMCBDIDIuMjA5MTM5LDAgNC4yMDg1MzQ4LDAuODk2MDM0NyA1LjY1NjI1LDIuMzQzNzUgNy4xMDM5NjUzLDMuNzkxNDY1MiA4LDUuNzkwODYxIDgsOCBWIDI0IEMgOCwyNi4yMDkxMzkgNy4xMDM5NjUzLDI4LjIwODUzNSA1LjY1NjI1LDI5LjY1NjI1IDQuMjA4NTM0OCwzMS4xMDM5NjUgMi4yMDkxMzksMzIgMCwzMiBjIDMuMzMzMzMzMywwIDYuNjY2NjY2NywwIDEwLDAgViAwIEMgNi4zNDY1MzY3LDAgMy41NTA2NTU0LDAgMCwwIFoiIC8+Cjwvc3ZnPgo=");
        }
        &:after {
            right: -14px;
            mask-image: url("data:image/svg+xml;base64,PHN2ZwogICB3aWR0aD0iMTAiCiAgIGhlaWdodD0iMzIiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGgKICAgICBkPSJNIDEwLDAgQyA3Ljc5MDg2MSwwIDUuNzkxNDY1MiwwLjg5NjAzNDcgNC4zNDM3NSwyLjM0Mzc1IDIuODk2MDM0NywzLjc5MTQ2NTIgMiw1Ljc5MDg2MSAyLDggdiAxNiBjIDAsMi4yMDkxMzkgMC44OTYwMzQ3LDQuMjA4NTM1IDIuMzQzNzUsNS42NTYyNSBDIDUuNzkxNDY1MiwzMS4xMDM5NjUgNy43OTA4NjEsMzIgMTAsMzIgNi42NjY2NjY3LDMyIDMuMzMzMzMzMywzMiAwLDMyIFYgMCBjIDMuNjUzNDYzMywwIDYuNDQ5MzQ0NiwwIDEwLDAgeiIgLz4KPC9zdmc+Cg==");
        }
    `;
}
//# sourceMappingURL=datePickerTheme.js.map